import { Component, Input } from '@angular/core';

@Component({
  selector: 'medrecord-ui-block-column-tag',
  templateUrl: './block-column-tag.component.html',
  styleUrls: ['./block-column-tag.component.scss']
})
export class BlockColumnTagComponent {
  @Input() value: string;
  @Input() color: string;
}